import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Contact from "../Contact/Contact.js";
import "./style.css";


import SnapEats from "../works/img/snapeats.jpg";

export default function DetailWork() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate()

  const handleClick = () => {
    navigate("/")
  }


  return (
    <>
      <nav onClick={handleClick} className='singleWork'>
        <p>Back</p>
      </nav>
    
      <div className="untree_co-section untree_co-section-4 pb-0" id="portfolio-section">
          <div className="container">
            <div className="portfolio-single-wrap unslate_co--section" id="portfolio-single-section">
              <div className="portfolio-single-inner">
                <h2 className="heading-portfolio-single-h2  mt-5" style={{color:"#063dcc"}}>SNAP EATS</h2>

                <div className="row justify-content-between mb-5">
                  <div className="col-12 mb-4">
                    <div className="owl-carousel single-slider">
                    </div>
                  </div>
                  <div className="col-12 my-5">
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Project Date</h4>
                          <span className="detail-val" style={{color:"#063dcc"}}>Mar - Aug - 2022</span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Role</h4>
                          <span className="detail-val">
                            <span style={{color:"#063dcc"}}>Admin - User</span>
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Code</h4>
                          <a style={{color:"#063dcc"}} href="https://github.com/ASFER8384/Snapeats.git" target="_blank" className="detail-val">Live Github</a>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Website</h4>
                          <span className="detail-val">
                            <a style={{color:"#063dcc"}} href="https://amethyst-puppy-slip.cyclic.app/" target="_blank">Live Site</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Snapeats is your go-to online destination for all things culinary. Discover a diverse world of flavors through our extensive collection of restaurant reviews, tantalizing recipes, and engaging food blogs. Unearth hidden gastronomic gems and draw inspiration for your next culinary masterpiece. We provide valuable dietary and nutritional insights, keeping you well-informed about healthy food choices. Stay up-to-date with the latest food trends, industry news, and exciting culinary events. Our community of passionate food enthusiasts welcomes you to share your culinary experiences.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    At Snapeats, we foster a sense of connection among food lovers from all walks of life. Our platform serves as the perfect hub for you to embark on a mouthwatering journey. Explore new tastes, experiment with exciting recipes, and learn from experienced foodies. Whether you're a seasoned chef or a novice home cook, Snapeats is your trusted companion in the world of food. Join us in celebrating the joy of culinary exploration and the pleasure of sharing delicious moments with a like-minded community
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Contact />
    </>
  );
}
